import BooleanView from '../../components/DataGrid/ValueViews/BooleanView';

const getColumnConfig = () => [
  {
    title: 'languageSettings.languageName',
    accessor: 'name',
    name: 'name',
    filterable: true,
    sortable: true,
  },
  {
    title: 'languageSettings.languageNameShort',
    accessor: 'isoCode',
    name: 'isoCode',
    filterable: true,
    sortable: true,
  },
  {
    title: 'languageSettings.flag',
    accessor: row => (
      <>
        {row.image ? (
          <img
            src={process.env.REACT_APP_STATIC_FILES_CDN + row.image.contentUrl}
            alt=""
            width="23px"
            height="17px"
          />
        ) : null}
      </>
    ),
    name: 'flag',
    filterable: false,
    sortable: false,
  },
  {
    title: 'columns.active.enabledForAdmin',
    accessor: row => <BooleanView value={row.enabledForAdmin} />,
    name: 'enabledForAdmin',
    sortable: false,
    filterable: false,
    width: 200,
  },
  {
    title: 'columns.active.enabledForClient',
    accessor: row => <BooleanView value={row.enabledForClient} />,
    name: 'enabledForClient',
    sortable: false,
    filterable: false,
    width: 200,
  },
];

export default getColumnConfig;
